import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { AuthTags } from '~constants/authTags';

import { ClickableIcon, ContainerHeader, TabContainer } from '~components';
import { faCog, faFileLines } from '~components/icon';

import CompletedFormsList from './CompletedFormsList';
import CustomFormsSettingsModal from './CustomFormsSettingsModal';
import FormTemplateList from './FormTemplateList';

const tabs = [
  { id: 'forms-templates', title: 'Templates', component: FormTemplateList },
  { id: 'forms-completed', title: 'Completed Forms', component: CompletedFormsList },
];

// `?tab=` values map to tab indexes so other pages (e.g. the completed-form viewer) can deep-link back
// to a specific tab. Unknown / missing → Templates (0).
const TAB_PARAMS = ['templates', 'completed'];

const FormsContainer: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = Math.max(0, TAB_PARAMS.indexOf(searchParams.get('tab') ?? ''));
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);

  const handleTabChange = (index: number) => {
    const next = new URLSearchParams(searchParams);
    next.set('tab', TAB_PARAMS[index]);
    setSearchParams(next, { replace: true });
  };

  return (
    <div className="p-2">
      <ContainerHeader icon={faFileLines} iconSize="1x" className="info" dataCy="forms-container-header">
        <div className="d-flex align-items-center gap-1">
          <span>Custom Forms</span>
          <ClickableIcon
            icon={faCog}
            id="forms-settings-button"
            toolTip="Edit Custom Forms Settings"
            ariaLabel="Custom forms settings"
            onClick={() => setIsSettingsOpen(true)}
            authTag={AuthTags.FORMS.CUSTOMFORMS.CREATE}
            dataCy="forms-settings-icon"
          />
        </div>
      </ContainerHeader>
      <TabContainer tabs={tabs} activeTab={activeTab} onTabChange={handleTabChange} />
      <CustomFormsSettingsModal setIsOpen={setIsSettingsOpen} isOpen={isSettingsOpen} />
    </div>
  );
};

export default FormsContainer;
